import { Content } from '../../types';

export const haGiangContent: Content = {
  title: "הא ג'יאנג: מסע בנופים עוצרי נשימה בצפון וייטנאם",
  imageUrl: '/images/vietnam/ha-giang/ha-giang-wide.jpeg',
  introduction:
    "הא ג'יאנג הינו מחוז קסום בצפון הרחוק של וייטנאם, סמוך לגבול עם סין. המחוז ידוע בזכות נופיו הדרמטיים: הרים גבוהים, מצוקים חדים, נהרות גועשים וטרסות אורז אינסופיות. הנוף הפראי והכפרים האותנטיים שבו הופכים אותו לאחד היעדים המיוחדים והמרהיבים ביותר לטיול בוייטנאם.",
  sections: [
    {
      title: "איך תגיעו להא ג'יאנג?",
      type: 'text',
      content:
        'הא ג\'יאנג שוכנת כ-300 ק"מ צפונית להאנוי והדרך הנוחה ביותר להגיע אליה הינה באמצעות אוטובוסי סליפר או ואנים מסוג לימוזין הפועלים לאורך היום והלילה. הנסיעה אורכת כ-6-8 שעות, תלוי באמצעי התחבורה שנבחר. ניתן להזמין כרטיסים באחת מסוכנויות הנסיעות בהאנוי או דרך המלונות בעיר.',
    },
    {
      title: "מהו הלופ של הא ג'יאנג?",
      type: 'text',
      content:
        'הדרך היפה ביותר לחוות את נופי המחוז הינה באמצעות "לופ הא ג\'יאנג" - מסלול מעגלי שאורכו כ-350 ק"מ, החוצה הרים, עמקים, כפרים אתניים ונקודות תצפית מרהיבות. ניתן לטייל במסלול זה על גבי אופנוע, ג\'יפ או במסגרת טיול מאורגן.',
    },
    {
      title: 'אפשרויות לטיול בלופ',
      type: 'list',
      content: [
        {
          subtitle: 'טיול עצמאי על אופנוע',
          text: "אופציה פופולרית עבור מטיילים בעלי ניסיון ברכיבה. ניתן לשכור אופנועים בעיר הא ג'יאנג, אך חשוב להיות מודעים לתנאי הדרך המאתגרים.",
        },
        {
          subtitle: 'טיול עם נהג מקומי',
          text: 'מתאים לאלו המעוניינים לחוות את הדרך בבטחה, ללא הצורך לנהוג בעצמו.',
        },
        {
          subtitle: "טיול בג'יפ או רכב שטח",
          text: 'מתאים לאלו המעדיפים נוחות ולמטיילים בקבוצות קטנות.',
        },
        {
          subtitle: 'טיולים מאורגנים',
          text: 'קיימות חברות רבות המציעות חבילות טיול של 3-4 ימים הכוללות לינה, אוכל ומדריך מקומי.',
        },
      ],
    },
    {
      title: 'נקודות עניין לאורך המסלול',
      type: 'list',
      content: [
        {
          subtitle: "מעבר קו ההרים Quan Ba Heaven's Gate",
          text: 'תצפית מרהיבה על ההרים והעמקים הירוקים.',
        },
        {
          subtitle: 'הרי התאומים Tam Son',
          text: 'תופעה גיאולוגית מיוחדת הנמצאת ליד העיירה קוואן בה.',
        },
        {
          subtitle: 'קניון Ma Pi Leng',
          text: 'אחד הקניונים היפים ביותר בוייטנאם, עם תצפית מרהיבה על נהר ho Que.',
        },
        {
          subtitle: 'שייט בנהר ho Que',
          text: 'חוויה בלתי נשכחת בין מצוקים תלולים.',
        },
        {
          subtitle: 'העיר דונג ואן (Dong Van)',
          text: 'אחת הערים המרכזיות בלופ, ידועה בשוק האתני הצבעוני שלה.',
        },
        {
          subtitle: 'הכפר מיאו ואק (Meo Vac)',
          text: 'מקום מצוין להכיר את אורח החיים של בני שבטי המיעוטים.',
        },
        {
          subtitle: "הכפר דו צ'ה (Du Gia)",
          text: 'כפר שליו עם נופים קסומים, נהר צלול ואווירה רגועה. מקום מצוין לעצור ללילה.',
        },
        {
          subtitle: 'מערת לונג קה (Lung Khuy Cave)',
          text: 'מערה יפהפייה עם נטיפים וזקיפים, הנמצאת לא רחוק מהעיירה קוואן בה.',
        },
        {
          subtitle: 'השוק של באק הא (Bac Ha Market)',
          text: 'אחד השווקים האותנטיים והצבעוניים ביותר בצפון וייטנאם, פעיל בעיקר בסופי שבוע.',
        },
      ],
    },
    {
      title: 'תרבות ואוכל מקומי',
      type: 'text',
      content:
        'המחוז מאוכלס בעיקר בבני שבטים אתניים כמו ההמונג, דאו וטאי, אשר שומרים על אורח חייהם המסורתי. מומלץ לנסות מאכלים מקומיים כמו מרק "Thang Co" (מרק בשר מסורתי) ואורז דביק בצבעים טבעיים.',
    },
    {
      title: 'מתי כדאי להגיע?',
      type: 'text',
      content:
        "העונה הטובה ביותר לטייל בהא ג'יאנג הינה מספטמבר עד נובמבר (עונת הסתיו, כאשר מזג האוויר נעים ויבש) או מאפריל עד מאי (כאשר טרסות האורז בירוק עז). כדאי להימנע מהחורף (דצמבר-פברואר) עקב מזג אוויר קר במיוחד ומהקיץ (יוני-אוגוסט) שבו יש סיכוי גבוה לגשמים.",
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        "בשורה התחתונה, הא ג'יאנג מציעה חווית טיול ייחודית עם נופים עוצרי נשימה, תרבות מסורתית עשירה ותחושת הרפתקה אמיתית. בין אם תבחרו לטייל על אופנוע, בג'יפ או במסגרת טיול מאורגן - החוויה בלופ של הא ג'יאנג הינה בלתי נשכחת ומומלצת לכל חובבי הטבע וההרפתקאות!",
    },
  ],
};
